(ns buzz-bot.views.bookmarks
  (:require [re-frame.core :as rf]
            [reagent.core :as r]
            [buzz-bot.subs :as subs]
            [buzz-bot.events :as events]))

(defn- downloaded-section []
  (let [open? (r/atom true)]
    (fn []
      (let [ids        @(rf/subscribe [::subs/cached-ids-vec])
            metas      @(rf/subscribe [::subs/cached-episode-metas])
            playing-id @(rf/subscribe [::subs/audio-episode-id])]
        (when (seq ids)
          [:div.downloaded-section
           [:div.downloaded-section-header
            {:on-click #(swap! open? not)}
            [:span.downloaded-section-title (str "Downloaded (" (count ids) ")")]
            [:span.downloaded-chevron (if @open? "▾" "▸")]]
           (when @open?
             [:ul.downloaded-list
              (for [ep-id ids]
                (let [meta (get metas (str ep-id))]
                  ^{:key ep-id}
                  [:li.episode-item
                   {:class           (when (= (str ep-id) (str playing-id)) "is-playing")
                    :data-episode-id (str ep-id)
                    :on-click        #(rf/dispatch [::events/navigate :player {:episode-id ep-id}])}
                   [:div.episode-info
                    [:span.episode-feed-name (or (:feed_title meta) "…")]
                    [:span.episode-title     (or (:title meta) (str "Episode " ep-id))]]
                   [:button.downloaded-delete
                    {:on-click (fn [e]
                                 (.stopPropagation e)
                                 (rf/dispatch [::events/audio-cache-evict ep-id]))}
                    "✕"]]))])])))))

(defn- episode-item [ep playing-id]
  [:li.episode-item
   {:class           (when (= (str (:id ep)) (str playing-id)) "is-playing")
    :data-episode-id (str (:id ep))
    :on-click        #(rf/dispatch [::events/navigate :player
                                    {:episode-id (:id ep) :from "bookmarks"}])}
   [:div.episode-info
    [:span.episode-feed-name (:feed_title ep)]
    [:span.episode-title     (:title ep)]]
   [:span.episode-play-icon "▶"]])

(defn view []
  (let [query-atom (r/atom "")
        debounce   (atom nil)]
    (fn []
      (let [episodes   @(rf/subscribe [::subs/bookmarks-list])
            loading?   @(rf/subscribe [::subs/bookmarks-loading?])
            playing-id @(rf/subscribe [::subs/audio-episode-id])]
        [:div.episodes-container
         [:div.section-header
          [:div.section-header-row [:h2 "Bookmarks"]]]
         [downloaded-section]
         [:div.search-section
          [:input.search-input
           {:type        "search"
            :placeholder "Search all episodes..."
            :on-change   (fn [e]
                           (let [v (.. e -target -value)]
                             (reset! query-atom v)
                             (when @debounce (js/clearTimeout @debounce))
                             (reset! debounce
                               (js/setTimeout
                                 #(rf/dispatch [::events/search-bookmarks v])
                                 300))))}]]
         (cond
           loading?          [:div.loading "Loading..."]
           (empty? episodes) [:div.empty-msg "No bookmarks yet. Like an episode to save it."]
           :else
           [:ul.episode-list
            (for [ep episodes]
              ^{:key (:id ep)} [episode-item ep playing-id])])]))))
